import React from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '@/common/SafeIcon';
import { useLanguage } from '../context/LanguageContext';
import LanguageToggle from '@/components/LanguageToggle';

const { FiArrowLeft } = FiIcons;

export default function Imprint() {
  const navigate = useNavigate();
  const { t } = useLanguage();

  return (
    <div className="min-h-screen bg-zinc-950 text-zinc-50 pb-24">
      <LanguageToggle />
      <header className="sticky top-0 z-50 bg-zinc-950/80 backdrop-blur-md border-b border-zinc-900 px-6 py-4">
        <div className="max-w-3xl mx-auto flex items-center">
          <button 
            onClick={() => navigate('/')}
            className="p-2 -ml-2 text-zinc-400 hover:text-zinc-50 transition-colors flex items-center gap-2 group"
          >
            <SafeIcon icon={FiArrowLeft} className="text-xl group-hover:-translate-x-1 transition-transform" />
            <span className="text-xs font-bold tracking-widest uppercase">{t.ui.back}</span>
          </button>
        </div>
      </header>

      <main className="max-w-3xl mx-auto px-6 mt-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h1 className="text-4xl font-bold tracking-tight mb-12">{t.legal.imprintTitle}</h1>
          
          <div className="space-y-12">
            <section>
              <h2 className="text-xs font-bold tracking-[0.3em] uppercase text-zinc-500 mb-4">
                {t.legal.responsible}
              </h2>
              <p className="text-xl text-zinc-200">Mathias Deppe</p>
            </section>

            <section>
              <h2 className="text-xs font-bold tracking-[0.3em] uppercase text-zinc-500 mb-4">
                {t.legal.address}
              </h2>
              <p className="text-lg text-zinc-300 leading-relaxed">
                Nemesi Valls 42<br />
                08210 Barberà del Vallès<br />
                Barcelona, Spain
              </p>
            </section>

            <section>
              <h2 className="text-xs font-bold tracking-[0.3em] uppercase text-zinc-500 mb-4">
                {t.legal.contact}
              </h2>
              <a 
                href="mailto:contact@barberadelvalles.bar" 
                className="text-lg text-zinc-200 hover:text-white underline underline-offset-8 decoration-zinc-800 hover:decoration-zinc-400 transition-all font-medium"
              >
                contact@barberadelvalles.bar
              </a>
            </section>

            <section className="pt-12 border-t border-zinc-900">
              <p className="text-sm text-zinc-500 leading-relaxed mb-8">
                {t.lang === 'es' 
                  ? "Este sitio web es un directorio independiente curado para Barberà del Vallès."
                  : "This website is an independent directory curated for Barberà del Vallès."}
              </p>
              
              <Link 
                to="/privacy" 
                className="text-[10px] font-bold tracking-[0.4em] uppercase text-zinc-500 hover:text-zinc-100 transition-colors"
              >
                {t.ui.privacy}
              </Link>
            </section>
          </div>
        </motion.div>
      </main>
    </div>
  );
}